import { render, staticRenderFns } from "./InstallBanner.vue?vue&type=template&id=4c02208e&scoped=true&"
import script from "./InstallBanner.vue?vue&type=script&lang=js&"
export * from "./InstallBanner.vue?vue&type=script&lang=js&"
import style0 from "./InstallBanner.vue?vue&type=style&index=0&id=4c02208e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02208e",
  null
  
)

export default component.exports